import { API_ROUTES } from '@/constant/routes';
import { APIUrlGenerator } from '@/lib/helper';
import {
  advertisementResType,
  checkWalletInquiryBody,
  confirmResType,
  createTransaction,
  createTransactionResType,
  finalInvoiceResType,
  invoicesType,
  loginInitResType,
  postInitOtpBodyType,
  postOtpBodyType,
  postOtpType,
  postRetryBodyType,
  segmentsResType,
  validateSelectionBodyType,
  validateSelectionResType,
  validateSelectionsBodyType,
  validateSelectionsResType,
  verifyOtpBody,
  vouchersResType,
} from '@/services/models/api.models';
import { httpGetRequest, httpPostRequest } from '@/lib/interceptors';

export async function postInitOTP (body: postInitOtpBodyType){
  const data: {data:loginInitResType} = await httpPostRequest(APIUrlGenerator(API_ROUTES.POST_INIT_OTP), body);
  return data.data
}
export async function postOTPLogin(body: postOtpBodyType) {
  const data: {
      data: postOtpType;
  } = await httpPostRequest(APIUrlGenerator(API_ROUTES.POST_LOGIN), body);
  return data.data;
}

export async function postRetry(body: postRetryBodyType) {
  const data: {
      data: verifyOtpBody;
  } = await httpPostRequest(APIUrlGenerator(API_ROUTES.POST_RETRY), body);
  return data.data;
}

export async function getInvoices() {
  const data: invoicesType  = await httpGetRequest(
    APIUrlGenerator(API_ROUTES.GET_INVOICES),
  );
  return data;
}

export async function getSegments() {
  const data: segmentsResType = await httpGetRequest(
    APIUrlGenerator(API_ROUTES.GET_SEGMENTS)
  )
  return data
}

export async function getVouchers() {
  const data: vouchersResType = await httpGetRequest(
    APIUrlGenerator(API_ROUTES.GET_VOUCHERS)
  )
  return data
}

export async function postValidateSelection(body: validateSelectionBodyType) {
  const data: {
      data: validateSelectionResType;
  } = await httpPostRequest(APIUrlGenerator(API_ROUTES.POST_VALIDATION_SEGMENTS), body);
  return data.data;
}

export async function postValidateSelections(body: validateSelectionsBodyType) {
  const data: {
    data: validateSelectionsResType;
  } = await httpPostRequest(APIUrlGenerator(API_ROUTES.POST_VALIDATE_SEGMENTS_AND_VOUCHERS), body);
  return data.data;
}

export async function postCreateTransactions(body: createTransaction) {
  const data: {
    data: createTransactionResType;
  } = await httpPostRequest(APIUrlGenerator(API_ROUTES.POST_CREATE_TRANSACTIONS), body);
  return data.data;
}

export async function postConfirm(body:{WalletProviderOTP?:string}) {
  const data: {
    data: confirmResType;
  } = await httpPostRequest(APIUrlGenerator(API_ROUTES.POST_CONFIRM), body);
  return data.data;
}

export async function getFinalInvoice() {
  const data: finalInvoiceResType = await httpGetRequest(
    APIUrlGenerator(API_ROUTES.GET_INVOICE_RECEIPT)
  )
  return data
}

export async function getAdvertisement(tag: number, pgc: string) {
  const data: advertisementResType = await httpGetRequest(
    APIUrlGenerator(API_ROUTES.GET_Advertisement, { Tag: tag, PaymentGatewayCode: pgc }),
  );
  return data;
}

export async function PostLoginOptions(body: {}) {
  const data: any = await httpPostRequest(APIUrlGenerator(API_ROUTES.POST_LOGIN_OPTIONS), body);
  return data;
}

export async function PostLoginComplete(body: {}) {
  const data: any = await httpPostRequest(
    APIUrlGenerator(API_ROUTES.POST_LOGIN_COMPLETE),
    body,
  );
  return data;
}

export async function PostRequestCall({}) {
  const data: any = await httpPostRequest(APIUrlGenerator(API_ROUTES.POST_REQUEST_CALL), {});
  return data;
}

export async function PostCancelCall({}) {
  const data: any = await httpPostRequest(
    APIUrlGenerator(API_ROUTES.POST_CANCEL_CALL),
    {},
  );
  return data;
}

export async function PostCheckWalletInquiry(body: checkWalletInquiryBody) {
  const data: any = await httpPostRequest(
    APIUrlGenerator(API_ROUTES.POST_CHECK_WALLET_INQUIRY),
    body,
  );
  return data;
}